import { JsonObject, JsonProperty } from 'json2typescript';

import { OtherProfessionalPosition } from './other-professional-position';
import { OtherProfessionalPositionCategoryInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('OtherProfessionalPositionCategory')
export class OtherProfessionalPositionCategory implements OtherProfessionalPositionCategoryInterface {
    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('OtherPositions', [OtherProfessionalPosition], true)
    private _otherPositions: OtherProfessionalPosition[] = undefined;

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get positions(): OtherProfessionalPosition[] {
        return this._otherPositions;
    }

    set positions(value: OtherProfessionalPosition[]) {
        this._otherPositions = value;
    }
}
